<app-breadcrumbs
	[headerTitle]="headerCrumb"
	[externalCrumbs]="externalCrumbs"
	[showAllCrumbs]="true"
	[showSideNav]="false"
	(onExternalDropDownCrumbItemSelected)="routeToMilestonePage($event)"
/>
@if (payGroup) {
<div class="tpp-payment-order-container">
	<div class="data-input-container" (mouseleave)="showInputDropDown(true)">
		<div class="button-containers">
			<button
				(click)="loadSubServices(pageSize, pageIndex, milestone.id!, payCycle.id, milestone.group)"
				id="refreshButton"
				class="refresh-button"
				mat-icon-button
			>
				<app-icon
					[name]="'rotate-right'"
					[color]="'var(--color-text-default)'"
					[lineWidth]="'1.5px'"
					[size]="'24'"
				></app-icon>
			</button>

			<div class="ttp-buttons">
				<button class="tpp-files" (click)="goToTppFiles()">
					<app-icon
						class="tpp-files-icon"
						[name]="'eye'"
						[color]="'var(--color-upload-button-dark-grey)'"
						[lineWidth]="'1.5px'"
						[size]="'24'"
					></app-icon>
					<span class="tpp-files-text">TPP FILES</span>
				</button>
				@if (canUploadFile) {
				<button
					class="data-input"
					[ngClass]="{ 'data-input-icon-touched': showDropDown }"
					(click)="showInputDropDown(showDropDown)"
				>
					<app-icon
						class="data-input-icon"
						[name]="'document-1'"
						[color]="'var(--color-white)'"
						[lineWidth]="'1.5px'"
						[size]="'24'"
					></app-icon
					><span class="data-input-text">PAYMENT ORDERS</span>
				</button>
				}
			</div>
		</div>
		<div class="data-input-options-container">
			@if(showDropDown) {
			<div class="data-input-options" (mouseleave)="showInputDropDown(showDropDown)">
				<button mat-button class="upload-template dropdown-buttons" (click)="uploader.click()">
					<app-icon
						class="upload-template-icon option-icon"
						[name]="'document-upload'"
						[color]="'var(--color-upload-button-dark-grey)'"
						[lineWidth]="'1.5px'"
						[size]="'24'"
					></app-icon>

					<span class="upload-template-text option-text">Upload template</span>
				</button>
			</div>
			}
		</div>
	</div>

	<input
		id="uploadButton"
		hidden
		type="file"
		#uploader
		(change)="uploadFile(uploader.files)"
		(click)="uploader.value = ''"
	/>

	@if (subServices?.length) {
	<app-tpp-subservice-list
		[_subServices]="subServices"
		(emitOpenPopUp)="viewDetails($event, 10, 0)"
	></app-tpp-subservice-list>
	} @if (!subServices?.length) {
	<no-items-layout message="No files have been uploaded"></no-items-layout>
	} @if (showPopup && (subserviceToView || subserviceToViewDetails)) {
	<app-view-subservice-details-side-pop-up
		(cancelDetails)="hideDetails(true)"
		(saveDetails)="saveDetails($event)"
		(emitNewPaginition)="paginateEmployees($event)"
		[_subService]="subserviceToView"
		[_pageSize]="popUpPageSize"
		[_pageIndex]="popUpPageIndex"
		[_subserviceToViewDetails]="subserviceToViewDetails"
	></app-view-subservice-details-side-pop-up>
	}
</div>
}
